import { createEnvelopeSource } from './create-envelope-source';
import { withCampaignWindows } from './create-campaign-source';
import type { CampaignSourceConfig } from './create-campaign-source';
import { withCampaignRateWindows } from './create-campaign-rate-source';
import { ROAD_TO_REWARDS_CAMPAIGN_ID } from './road-to-rewards-campaign';

type PurchasesMetric =
    | 'storeVisits'
    | 'spend'
    | 'avgSpendPerMember'
    | 'avgSpendPerTransaction'
    | 'avgUnitsPerTransaction';

const config: CampaignSourceConfig<PurchasesMetric> = {
    label: 'Campaign purchases',
    endpoint: 'analytics/campaign-purchases-member',
    metrics: [
        { id: 'storeVisits', label: 'Store visits', type: 'scalar' },
        { id: 'spend', label: 'Spend', type: 'scalar', isCurrency: true },
        // Ratios, not scalars: the endpoint carries each as a numerator/
        // denominator pair (see six12-purchases.ts's `avgSpend`).
        {
            id: 'avgSpendPerMember',
            label: 'Avg. spent per member',
            type: 'ratio',
            isCurrency: true,
        },
        {
            id: 'avgSpendPerTransaction',
            label: 'Avg. spent per transaction',
            type: 'ratio',
            isCurrency: true,
        },
        {
            id: 'avgUnitsPerTransaction',
            label: 'Avg. units per transaction',
            type: 'ratio',
        },
    ],
    forms: ['trio', 'rate-trio'],
    regionGrain: 'province',
    staticParams: { campaignId: ROAD_TO_REWARDS_CAMPAIGN_ID },
    // Per-transaction: the denominator grows with the window as fast as the
    // numerator, so no window average exists for either at any width. Their
    // cards read `rate-trio` (three real windows) instead; this keeps a `trio`
    // card on them honest rather than letting one divide a ratio by its days.
    intensiveMetrics: ['avgSpendPerTransaction', 'avgUnitsPerTransaction'],
};

export const campaignPurchasesSource = withCampaignRateWindows(
    withCampaignWindows(createEnvelopeSource(config), config),
    config
);
